import {
  BottomSheetContainer,
  Colors,
  createUseBottomSheetModal,
  Flex,
  IconArrowRight,
  List,
  Typography,
} from '@banhala/ui-kit';
import { useGoodsAwards } from '../queries/useGoodsAwards';
import React from 'react';
import { useOnPressAwardDeeplink } from '../hooks/useOnPressAwardDeeplink';

export const useGoodsAwardListBottomSheet = createUseBottomSheetModal(() => {
  const { data: goodsAwardList } = useGoodsAwards();
  const onPressAwardDeeplink = useOnPressAwardDeeplink();

  return (
    <BottomSheetContainer title={'수상정보'} maxHeight={'60%'}>
      <List
        data={goodsAwardList?.awards ?? []}
        renderItem={({ item: award }) => {
          return (
            <Flex
              padding={{ horizontal: 16, vertical: 16 }}
              onPress={() => {
                onPressAwardDeeplink(award.deeplink);
              }}
            >
              <Flex.Row
                alignSelf={'stretch'}
                alignItems={'center'}
                justifyContent={'space-between'}
                width={'100%'}
              >
                <Typography type={'body2'} color={'content_primary'}>
                  {award.title}
                </Typography>
                <IconArrowRight size={16} color={Colors.content_tertiary} />
              </Flex.Row>
              <Flex.Row
                alignItems={'center'}
                justifyContent={'space-between'}
                padding={{ vertical: 4 }}
              >
                <Typography type={'body3'} color={'content_tertiary'}>
                  {award.description}
                </Typography>
              </Flex.Row>
            </Flex>
          );
        }}
      ></List>
    </BottomSheetContainer>
  );
});
